import { WorkerOnBoardingRoutesMixin } from '@/portal/worker-on-boarding/mixins';

// @vue/component
export default {
  mixins: [
    WorkerOnBoardingRoutesMixin,
  ],
};
